import {v4 as uuid} from 'uuid';

export function stringToFile(stringData: string, fileName?: string): File {
  const blob = new Blob([stringData], {type: 'text/plain'});
  return new File([blob], fileName ?? uuid(), {type: 'text/plain'});
}
